import React from 'react'
import Loadable from 'react-loadable'

import { Switch, BrowserRouter as Router, Route, Link } from 'react-router-dom'

import ajax from './components/ControlPanel/utils/ajax'
import globalConfig from './components/ControlPanel/config'

import PropTypes from 'prop-types'
import classNames from 'classnames'

import { withStyles } from 'material-ui/styles'
import Drawer from 'material-ui/Drawer'
import AppBar from 'material-ui/AppBar'
import Button from 'material-ui/Button'
import Toolbar from 'material-ui/Toolbar'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import Hidden from 'material-ui/Hidden'
import Divider from 'material-ui/Divider'
import { CircularProgress } from 'material-ui/Progress'
import Avatar from 'material-ui/Avatar'
import { MdMenu, MdChevronLeft } from 'react-icons/lib/md'

import { AppBarStyles } from './styles/Styles'

import NoMatch from './views/NotMatched'

import Favicon from '../public/favicon.png'

import './styles/App.scss'


const Loading = <div className="Center"><CircularProgress size={80} /></div>

const LoadableHome = Loadable({
  loader: () => import('./views/TopicDl4Health'),
  loading() {
    return Loading
  },
})

const LoadableTopicPage = Loadable({
  loader: () => import('./views/TopicDl4Health'),
  loading() {
    return Loading
  },
})

class Dl4Health extends React.Component {
  state = {
    mobileOpen: false,
    open: false,
    menu: [],
    menuSide: <div />,
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen })
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    this.setState({ open: false })
  }

  async componentWillMount() {
    // console.log("data:", summary)
    const data = await ajax.get(`${globalConfig.getAPIV2Path()}/topic/dl4health.org/summary`, {
      params: {
        // id: summary.data.id,
      },
    })
    console.log("data@@@,", data.data.sub)
    // data.data.map((item, id) => {
    //     console.log(item.id)
    // })

    let menu = data.data.sub

    let listItems = menu.map((k, i) => {
      console.log("k: %o, i: %o", k, i)
      return (<ListItem key={i} button component={props => <Link to={"/" + k.slug} {...props} />}>
        <ListItemText primary={k.title} />
      </ListItem>)
    })

    console.log("listItems@@@,", listItems)

    // {data: {…}, domain: "dl4health.org"}data: sub: Array(1)0: {id: "5b5a898f2bf0e900013f6c91", domain: "dl4health.org", title: "dl001:url:test", slug: "test", priority: 0}length: 1__proto__: Array(0)__proto__: Objectdomain: "dl4health.org"__proto__: Object

    let menuSide = (<div>
      {[...listItems]}
    </div>)

    this.setState({
      tryingLogin: false,
      menu,
      menuSide,
    })
  }

  render() {
    const { classes, theme } = this.props
    const { open } = this.state

    return (
      <Router>
        <div className={classes.root}>
          <AppBar
            className={classNames(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            <Toolbar disableGutters={!open}>
              <Hidden mdUp>
                <IconButton
                  color="primary"
                  aria-label="open drawer"
                  onClick={this.handleDrawerOpen}
                  className={classNames(classes.menuButton, open && classes.hide)} >
                  <MdMenu />
                </IconButton>
              </Hidden>
              <Button component={Link} to="/">
                <Typography variant="title" >
                  <Avatar src={Favicon} />
                </Typography>
                <Typography variant="title" noWrap className={classNames(classes.textInSecondary, 'Center')} style={{ fontFamily: 'Tinos' }}>
                  Sunlab
                </Typography>
              </Button>

              <Hidden smDown>
                <Route>
                  {({ location }) => {
                    const { pathname } = location
                    // console.log("loc: %o, len: %o", location, location.pathname.length)
                    let base = ''
                    if (pathname.length < 2) {
                      base = ''
                    } else {
                      const paths = pathname.split('/')
                      if (paths.length > 1) {
                        base = paths[1].toLowerCase()
                      }
                    }

                    let menu = this.state.menu

                    let listItems = menu.map((k, i) => {
                      console.log("k: %o, i: %o", k, i)
                      {/* return (<ListItem key={i} button component={props => <Link to={"/" + k.slug} {...props} />}>
                        <ListItemText primary={k.title} />
                      </ListItem>) */}
                      return (<Button key={i}
                        component={Link} to={"/" + k.slug}
                        className={base === k.slug ? classes.textInSecondary : classes.textInPrimary}
                      > {k.title}
                      </Button>)
                    })

                    let nav = (<div>
                      {[...listItems]}
                    </div>)

                    return nav

                    {/* return (
                      <div>
                        <Button className={base === 'about' ? classes.textInSecondary : classes.textInPrimary} >
                          <a href="http://sunlab.org" className={base === 'about' ? classes.textInSecondary : classes.textInPrimary} >SunLab</a>
                        </Button>
                      </div>) */}
                  }}
                </Route>
              </Hidden>
            </Toolbar>
          </AppBar>

          <Drawer
            variant="persistent"
            anchor="left"
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={this.handleDrawerClose}>
                <MdChevronLeft />
              </IconButton>
            </div>
            <Divider />

            <List>{this.state.menuSide}</List>

          </Drawer>

          <main className={classNames(classes.content, {
            [classes.contentShift]: open,
          })}>
            {/*  <div className={classes.toolbar} /> */}
            <div className={classes.drawerHeader} />
            <div className="Content">
              <Switch>
                <Route exact path="/" component={LoadableHome} />
                <Route path="/:alias" component={LoadableTopicPage} />
                <Route component={NoMatch} />
              </Switch>
            </div>
            <div className="clearfix" />
            <div className="Footer" />
          </main>
        </div>
      </Router>
    )
  }
}

Dl4Health.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(AppBarStyles, { withTheme: true })(Dl4Health)
